import React from 'react'

export const PostItem = ({ title, date, tag, excerpt, readTime }) => {
  return (
    <li className="post-card">
      <div className="post-card__header">
        <span className="post-card__tag">{tag}</span>
        <span className="post-card__date">{date}</span>
      </div>
      <h2 className="post-card__title">{title}</h2>
      <p className="post-card__excerpt">{excerpt}</p>
      <div className="post-card__footer">
        <span className="post-card__read-time">{readTime}</span>
        <button type="button" className="post-card__btn">Read more</button>
      </div>
    </li>
  )
}
